<template>

    <router-view />

</template>

<script>
export default
{
    name: 'Empty',
}
</script>


// WEBPACK FOOTER //
// Empty.vue?8f680608